module.exports = __webpack_public_path__ + "static/img/3muke.814a14bf.png";